export const FORM_STYLE_CONFIG = Object.freeze({
	formGroup: {
		default: 'm-content',
		condition: {
			notNormalForm: 'padding-null',
			normalForm: '',
		},
		portlet: {
			condition: {
				normalForm: 'm-portlet',
			},
			head: {
				default: 'm-portlet__head',
				caption: {
					default: 'm-portlet__head-caption',
					title: {
						default: 'm-portlet__head-title',
						label: {
							default: 'm-portlet__head-text label-style'
						}
					}
				}
			},
			body: {
				default: 'm-portlet__body',
				condition: {
					modalForm: 'padding-null',
					// modalForm: 'padding-null margin-top-negative-50',
					withoutStyle: 'padding-null',
					normalForm: 'form-padding'
				},
				section: {
					default: 'm-form__section m-form__section--first',
					heading: {
						default: 'm-form__heading margin-bottom-40',
						header: {
							default: 'm-form__heading-title form-subhead-label-style subheader',
						}
					},
					body: {
						default: 'row flex-row margin-left-2',
							inputElement: {
								default: 'm-form__group',
								condition: {
									withElementPadding: 'form-element-padding'
								},
								element: {
									default: '',
									condition: {
										row: 'row',
										flexRow: 'row flex-row'
									},
									label: {
										default: 'col-form-label field-label padding-top-zero',
										align: (part) => `col-md-${part}`,
										condition: {
											row: 'right-text'
										}
									},
									input: {
										default: 'form-control m-input justify-text notranslate',
										align: (part) => `col-md-${part}`,
										multiple: 'multiple notranslate',
										checkbox: 'm-checkbox m-checkbox--default notranslate'
									}
								},
								align: (part) => `col-md-${part}`
							}
					}
				}
			},
			button: {
				submit: {
					default : 'btn btn-primary'
				},
				cancel: {
					default: 'btn btn-secondary'
				}
			}
		},
		// parent: 'm-content',
		// notNormalForm: 'padding-null',
		// subParent: {
		// 	normalForm: 'm-portlet',
		// },
		// heading: {
		// 	parent: 'm-portlet__head',
		// 	subParent: 'm-portlet__head-caption',
		// 	title: {
		// 		parent: 'm-portlet__head-title',
		// 		label: 'm-portlet__head-text label-style'
		// 	},
		// },
		// body: {
		// 	parent: {
		// 		normal: 'm-portlet__body',
		// 		modalForm: 'padding-null margin-top-negative-50',
		// 		withoutStyle: 'padding-null',
		// 		normalForm: 'form-padding'
		// 	},
		// 	form: {
		// 		parent: 'm-form__section m-form__section--first',
		// 		heading: 'm-form__heading margin-bottom-40',
		// 		header: 'm-form__heading-title form-subhead-label-style subheader',
		// 		body: 'row flex-row margin-left-2',
		// 		inputElement: 'm-form__group',
		// 		align: (part) => `col-md-${part}`
		// 	}

		// }

	},
	datePicker: {
		default: 'local',
		local: '../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js',
		cdn: 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.8.0/js/bootstrap-datepicker.js'
	},
	select: {
		default: 'local',
		local: 'assets/demo/default/custom/components/forms/widgets/select2.js',
		cdn: 'https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.5/js/i18n/af.js'
	}
});
